module.exports = __webpack_public_path__ + "static/media/bpmeasurex-4.f3d3d175.jpg";